import {
  dateTimeCol,
  intCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
// import R from 'ramda'

export const SolarInverterGroupPerformanceHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    width: 150,
    isKey: true,
    isFiltered: true,
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isKey: true,
    isFiltered: true,
  }),
  strCol({
    ident: 'inverterGroupId',
    display: 'Inverter Group ID',
    isKey: true,
    isFiltered: true,
  }),
  // strCol({
  //   ident: 'inverterGroupName',
  //   display: 'Inverter Group Name',
  //   isFiltered: true,
  //   width: 150,
  //   sortOrder: 'asc',
  //   sortIndexGetter: ({ rowData }) =>
  //     rowData.inverterGroupName === 'TOTAL'
  //       ? 'ZZZZZZZ'
  //       : rowData.inverterGroupName,
  // }),
  intCol({ ident: 'year', display: 'Year', isFiltered: true }),
  intCol({ ident: 'month', display: 'Month', isFiltered: true }),
  strCol({
    ident: 'invGroupAvailability',
    display: 'Inverter Group Availability',
    width: 150,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'grossactgen',
    display: 'Gross Actual Generation (MWh)',
    width: 150,
    isFiltered: true,
  }),
  numCol({
    ident: 'netactgen',
    display: 'Net Actual Generation (MWh)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'netmaxcap',
    display: 'Net Max Capacity (MW)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'monthlyPoa',
    display: 'Monthly Plane of Array (MWh/m^2)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'performanceRatio',
    display: 'Performance Ratio',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'expectedGen',
    display: 'Expected Generation',
    isFiltered: true,
  }),
  numCol({
    ident: 'activeSolarIh',
    display: 'Active Solar IHrs (Day)',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'activeIh', display: 'Active IHrs', isFiltered: true }),
  numCol({
    ident: 'inactiveReserveIh',
    display: 'Inactive Reserve IHrs',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'mothballedIh',
    display: 'Mothballed IHrs',
    isFiltered: true,
  }),
  numCol({ ident: 'retiredIh', display: 'Retired IHrs', isFiltered: true }),
  numCol({
    ident: 'serviceIhDay',
    display: 'Service IHrs (Day)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'rsIh',
    display: 'Reserve Shutdown IHrs',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'foIhDay',
    display: 'Forced IHrs (Day)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'moIhDay',
    display: 'Maintenance IHrs (Day)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'poIhDay',
    display: 'Planned IHrs (Day)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'resourceUnaIhDay',
    display: 'Resource Unavailable IHrs (Day)',
    width: 150,
    isFiltered: true,
  }),
  numCol({
    ident: 'serviceIhNight',
    display: 'Service IHrs (Night)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'foIhNight',
    display: 'Forced IHrs (Night)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'moIhNight',
    display: 'Maintenance IHrs (Night)',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'poIhNight',
    display: 'Planned IHrs (Night)',
    isFiltered: true,
  }),
  numCol({
    ident: 'resourceUnaIhNight',
    display: 'Resource Unavailable IHrs (Night)',
    isFiltered: true,
    width: 150,
  }),
  // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
  // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
]

export const SolarNercEventHeaders = width => {
  // const conMap = R.compose(
  //   R.fromPairs,
  //   R.map(d => [d.contOpCode, d.contOpCode + ' - ' + d.contOpCondition])
  // )(contribConditionList)
  const headers = [
    // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
    // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
    // strCol({ ident: 'entityId', display: 'NCR ID/NERC ID', isKey: true }),
    // strCol({ ident: 'plantId', display: 'Plant ID', isKey: true }),
    strCol({
      ident: 'eventId',
      display: 'Event ID',
      isKey: true,
      sortOrder: 'asc',
    }),
    // strCol({ ident: 'timeZone', display: 'Time Zone', isKey: true }),
    dateTimeCol({
      ident: 'eventstart',
      display: 'Event Start',
      isKey: true,
      sortOrder: 'asc',
      width: 200,

      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
    }),
    dateTimeCol({
      ident: 'eventend',
      display: 'Event End',
      isFiltered: true,
      sortOrder: 'asc',
      width: 200,

      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
    }),
    strCol({
      ident: 'eventtype',
      display: 'Event Type',
      isFiltered: true,
      sortOrder: 'asc',
      isEditable: true,
    }),
    intCol({
      ident: 'causecode',
      display: 'Causecode',
      isFiltered: true,
      sortOrder: 'asc',
    }),
    strCol({
      ident: 'contributingCondition',
      display: 'Contributing Op. Condition',
      isFiltered: true,
      // ...toSelectionColProps(conMap),
      alignment: 'left',
      width: 100,
      ellipsis: true,
    }),
    numCol({
      ident: 'potentialLoss',
      display: 'Potential Generation Loss (MWh)',
      isFiltered: true,
      width: 200,
    }),
    intCol({
      ident: 'causecode1',
      display: 'Causecode 1',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode2',
      display: 'Causecode 2',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode3',
      display: 'Causecode 3',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode4',
      display: 'Causecode 4',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode5',
      display: 'Causecode 5',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode6',
      display: 'Causecode 6',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode7',
      display: 'Causecode 7',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode8',
      display: 'Causecode 8',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode9',
      display: 'Causecode 9',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
    intCol({
      ident: 'causecode10',
      display: 'Causecode 10',
      isFiltered: true,
      width: 100,
      ellipsis: true,
    }),
  ]
  const lastHeaders = [modifierCol, modifiedDateCol]

  const getWidth = hd => hd.map(h => h.width || 100).reduce((a, b) => a + b)

  let descwidth = width - getWidth(headers) - getWidth(lastHeaders) - 20
  if (descwidth < 0) descwidth = 150
  const desc = strCol({
    ident: 'description',
    display: 'Event Description',
    isFiltered: true,
    width: descwidth,
    ellipsis: true,
    alignment: 'left',
  })
  return [...headers, desc, ...lastHeaders]
}

export const SolarPlantHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isKey: true,
    width: 200,
    ellipsis: true,
  }),
  strCol({ ident: 'plantId', display: 'Plant ID', isKey: true, width: 200 }),
  strCol({
    ident: 'plantName',
    display: 'Plant Name',
    isRequired: true,
    width: 200,
    ellipsis: true,
  }),
  strCol({
    ident: 'region',
    display: 'Region',
    isRequired: true,
    width: 250,
    ellipsis: true,
  }),
  strCol({
    ident: 'eiaPlantCode',
    display: 'EIA Plant Code',
    isRequired: true,
    width: 200,
    ellipsis: true,
  }),
  strCol({
    ident: 'isoResourceId',
    display: 'ISO ID',
    isFiltered: true,
  }),
  strCol({
    ident: 'plantOwnershipStatus',
    display: 'Plant Ownership Status',
    isFiltered: true,
    width: 100,
    isRequired: true,
  }),
  strCol({
    ident: 'effectiveDate',
    display: 'Effective Date (mm/dd/yyyy)',
    isFiltered: true,
    isRequired: true,
    width: 200,
  }),
  strCol({
    ident: 'country',
    display: 'Country',
    isFiltered: true,
    width: 200,
    ellipsis: true,
    isRequired: true,
  }),
  strCol({
    ident: 'stateProvince',
    display: 'State/Province',
    isFiltered: true,
    width: 200,
    ellipsis: true,
    isRequired: true,
  }),
  strCol({
    ident: 'nearestCity',
    display: 'Nearest City',
    isFiltered: true,
    width: 200,
    ellipsis: true,
    isRequired: true,
  }),

  strCol({
    ident: 'timeZone',
    display: 'Time Zone',
    isFiltered: true,
    width: 200,
    ellipsis: true,
    isRequired: true,
  }),
  strCol({
    ident: 'daylightSaving',
    display: 'Daylight Savings',
    isFiltered: true,
    // ...toSelectionColProps(yesNoMap),
    width: 100,
    isRequired: true,
  }),
  numCol({
    ident: 'solarRegime',
    display: 'Solar Regime',
    isFiltered: true,
    // width: 450,
    ellipsis: true,
    isRequired: true,
  }),
  numCol({
    ident: 'latitude',
    display: 'Latitude (DD)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'longitude',
    display: 'Longitude (DD)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'elevationM',
    display: 'Elevation (m)',
    isFiltered: true,
    isRequired: true,
  }),

  numCol({
    ident: 'globalHIrradiance',
    display: 'Global Horizontal Irradiance (kWh/m^2)',
    width: 200,
    ellipsis: true,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'interAnnualVarIrr',
    display: 'Inter-Annual Variance of Irradiance',
    isFiltered: true,
    width: 150,
    isRequired: true,
  }),
  numCol({
    ident: 'plantCapPoi',
    display: 'Plant Capacity at POI (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'onSiteStorage',
    display: 'On-Site Storage (Yes/No)',
    isFiltered: true,
    isRequired: true,
    // ...toSelectionColProps(yesNoMap),
  }),
  // strCol({
  //   ident: 'transferToEntityId',
  //   display: 'Transfer to Entity ID',
  //   isFiltered: true,
  // }),

  // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
  // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
]

export const SolarInverterGroupHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isKey: true,
    width: 200,
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isKey: true,
    width: 200,
    ellipsis: true,
  }),
  strCol({
    ident: 'inverterGroupId',
    display: 'Inverter Group ID',
    isKey: true,
    width: 200,
  }),
  strCol({
    ident: 'inverterGroupName',
    display: 'Inverter Group Name',
    isRequired: true,
    width: 200,
  }),
  strCol({
    ident: 'commissionDateStr',
    display: 'Commission Date (mm/dd/yyyy)',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'effectiveDateStr',
    display: 'Effective Date (mm/dd/yyyy)',
    isRequired: true,
    width: 150,
  }),
  numCol({
    ident: 'groupInstalledCap',
    display: 'Group Installed Capacity (MW)',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  intCol({
    ident: 'numInverters',
    display: 'Number of Inverters',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  numCol({
    ident: 'singleInvSystemCap',
    display: 'Single Inverter System Capacity (MW)',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  numCol({
    ident: 'singleInvNameplateCap',
    display: 'Single Inverter Nameplate Capacity (MW)',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'invOwnershipStatus',
    display: 'Inverter Ownership Status',
    // isKey: true,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'invManufacturer',
    display: 'Inverter Manufacturer',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'invModel',
    display: 'Inverter Model',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'scadaManufacturer',
    display: 'SCADA Manufacturer',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'scadaModel',
    display: 'SCADA Model',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'dcInputType',
    display: 'DC Input Type',
    isFiltered: true,
    width: 250,
  }),
  numCol({
    ident: 'dcAcFieldCapRatio',
    display: 'Aggregate DC to AC Field Capacity Ratio',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'panelTrackingType',
    display: 'Panel Tracking Type',
    isFiltered: true,
    width: 200,
  }),
  intCol({
    ident: 'panelTiltAngle',
    display: 'Panel Titlt Angle (degree)',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'minIrradiance',
    display: 'Minimum Irradiance (W/m^2)',
    isFiltered: true,
    width: 200,
  }),
  intCol({
    ident: 'stowingWindSpeed',
    display: 'Stowing Wind Speed (m/s)',
    isFiltered: true,
  }),
  intCol({
    ident: 'minOpTemperature',
    display: 'Minimum Operating Temperature (C)',
    isFiltered: true,
    width: 200,
  }),
  intCol({
    ident: 'maxOpTemperature',
    display: 'Maximum Operating Temperature(C)',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'temperatureCoefficient',
    display: 'Temperature Coefficient (%/deg C)',
    isFiltered: true,
    width: 200,
  }),
  numCol({
    ident: 'nameplateEfficiency',
    display: 'Nameplate Efficiency (%)',
    isFiltered: true,
    width: 200,
  }),

  //
]

export const SolarEnergyStoragePerformanceHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'storageGroupId',
    display: 'Storage Group Id',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'storageGroupAvailability',
    display: 'Availability Status',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  numCol({
    ident: 'chargeMwh',
    display: 'Charge MWh',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeMwh',
    display: 'Discharge MWh',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'chargeHrs',
    display: 'Charge Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeHrs',
    display: 'Discharge Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'foHrs',
    display: 'FO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'moHrs',
    display: 'MO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'poHrs',
    display: 'PO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
]
